import { useCallback } from 'react';
import { atom, useAtom, useSetAtom } from 'jotai';

// Mirrors the DocumentSearch location filters: a single-select state that scopes
// a multi-select region dropdown, which in turn scopes a multi-select city
// dropdown. City selections are stored as city *codes* because the company
// search API filters on `project_city_codes`.
const stateFilterAtom = atom<string>('');
stateFilterAtom.debugLabel = 'companyStateFilter';

const regionFilterAtom = atom<string[]>([]);
regionFilterAtom.debugLabel = 'companyRegionFilter';

const cityFilterAtom = atom<string[]>([]);
cityFilterAtom.debugLabel = 'companyCityFilter';

const companyTypeFilterAtom = atom<string[]>([]);
companyTypeFilterAtom.debugLabel = 'companyTypeFilter';

export const useCompanyStateFilter = () => {
  const [stateFilter, setStateFilter] = useAtom(stateFilterAtom);

  return { stateFilter, setStateFilter };
};

export const useCompanyRegionFilter = () => {
  const [regionFilter, setRegionFilter] = useAtom(regionFilterAtom);

  return { regionFilter, setRegionFilter };
};

export const useCompanyCityFilter = () => {
  const [cityFilter, setCityFilter] = useAtom(cityFilterAtom);

  return { cityFilter, setCityFilter };
};

export const useResetCompanyLocationFilters = () => {
  const setStateFilter = useSetAtom(stateFilterAtom);
  const setRegionFilter = useSetAtom(regionFilterAtom);
  const setCityFilter = useSetAtom(cityFilterAtom);

  const resetLocationFilters = useCallback(() => {
    setStateFilter('');
    setRegionFilter([]);
    setCityFilter([]);
  }, [setStateFilter, setRegionFilter, setCityFilter]);

  return { resetLocationFilters };
};

export const useCompanyTypeFilterState = () => {
  const [companyTypeFilter, setCompanyTypeFilter] = useAtom(companyTypeFilterAtom);

  const resetCompanyTypeFilter = useCallback(() => {
    setCompanyTypeFilter([]);
  }, [setCompanyTypeFilter]);

  return {
    companyTypeFilter,
    setCompanyTypeFilter,
    resetCompanyTypeFilter,
  };
};
